import { useTranslation } from "react-i18next";
import { FitIcon, MinusIcon, PlusIcon } from "./schemaIcons";

const ZOOM_BUTTON =
  "flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-[7px] border-none bg-transparent text-ink-2 transition-colors duration-150 hover:bg-fill disabled:cursor-not-allowed disabled:opacity-40";

// Къде стои: плаващо долу/горе вдясно в платното (редакторът) или в реда на
// страницата (напр. до легендата под схемата).
const PLACEMENT_CLASS = {
  bottom:
    "dk-elevated absolute bottom-5 right-5 z-30 bg-surface shadow-[0_1px_2px_rgba(28,25,23,0.08),0_6px_20px_rgba(28,25,23,0.10)]",
  top: "dk-elevated absolute right-3 top-3 z-30 bg-surface shadow-[0_1px_2px_rgba(28,25,23,0.08),0_6px_20px_rgba(28,25,23,0.10)]",
  inline: "border border-shade-2 bg-surface",
} as const;

export type ZoomPlacement = keyof typeof PLACEMENT_CLASS;

/**
 * − 100% + | Побери схемата. Стойностите идват от `useSchemaStage`
 * (`{...stage.zoomControls}`).
 */
const ZoomControls = ({
  placement,
  zoom,
  canZoomOut,
  canZoomIn,
  onZoomOut,
  onZoomIn,
  onFit,
}: {
  placement: ZoomPlacement;
  zoom: number;
  canZoomOut: boolean;
  canZoomIn: boolean;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onFit: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center rounded-[10px] p-[3px] ${PLACEMENT_CLASS[placement]}`}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        title={t("restaurantSchema.canvas.zoomOut")}
        aria-label={t("restaurantSchema.canvas.zoomOut")}
        disabled={!canZoomOut}
        onClick={onZoomOut}
        className={ZOOM_BUTTON}
      >
        <MinusIcon className="h-4 w-4" />
      </button>
      <span className="w-12 text-center text-[12.5px] font-semibold tabular-nums text-ink">
        {Math.round(zoom * 100)}%
      </span>
      <button
        type="button"
        title={t("restaurantSchema.canvas.zoomIn")}
        aria-label={t("restaurantSchema.canvas.zoomIn")}
        disabled={!canZoomIn}
        onClick={onZoomIn}
        className={ZOOM_BUTTON}
      >
        <PlusIcon className="h-4 w-4" />
      </button>
      <span className="mx-[3px] h-5 w-px bg-shade-3" />
      <button
        type="button"
        title={t("restaurantSchema.canvas.fit")}
        aria-label={t("restaurantSchema.canvas.fit")}
        onClick={onFit}
        className={ZOOM_BUTTON}
      >
        <FitIcon className="h-4 w-4" />
      </button>
    </div>
  );
};

export default ZoomControls;
